import { render, staticRenderFns } from "./Singular.vue?vue&type=template&id=83ade60c&"
import script from "./Singular.vue?vue&type=script&lang=js&"
export * from "./Singular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ade60c')) {
      api.createRecord('83ade60c', component.options)
    } else {
      api.reload('83ade60c', component.options)
    }
    module.hot.accept("./Singular.vue?vue&type=template&id=83ade60c&", function () {
      api.rerender('83ade60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Filters/Hospitals/Singular.vue"
export default component.exports